import { ACCENT, OK, BAD, WARN } from '../../lib/uiTokens';
import { fmtKratce, KAT_LABEL } from './bankaSdilene';
import { sestavNalezy } from './bankaNalezy';

/**
 * Třetí sloupec Banky. Norma (§1f) mu dává dvě úlohy a žádnou třetí:
 * **statistiky** a **„K dořešení"**. Nic se tu needituje.
 *
 * Panel je vázaný na ÚČET, ne na vybraný pohyb, takže se kreslí i v přehledu
 * (`panelVzdy` na `ModulLayout`). Do 3.481 byla tahle čísla nad seznamem
 * a ukrajovala mu výšku pokaždé — osm viditelných pohybů místo dvanácti.
 */
export default function BankaStatistikyPanel({ staty, cardStyle, obdobiLabel, ucetLabel, onPohled }) {
    if (!staty) {
        return (
            <div className="rounded-2xl p-4 text-sm" style={{ ...cardStyle, color: 'var(--text-tertiary)' }}>
                Načítám statistiky…
            </div>
        );
    }

    const zarazeni = (staty.podle_zarazeni || []).slice(0, 5);
    const maxZ = Math.max(1, ...zarazeni.map(z => Math.abs(z.suma)));
    const nalezy = sestavNalezy(staty);

    const Nadpis = ({ children }) => (
        <div className="text-[9.5px] font-bold uppercase mb-2"
            style={{ letterSpacing: '0.12em', color: 'var(--text-secondary)' }}>{children}</div>
    );
    const Radek = ({ popis, hodnota, barva, posledni }) => (
        <div className="flex items-baseline justify-between gap-2 py-[7px]"
            style={{ borderBottom: posledni ? 'none' : '1px solid var(--border-default)' }}>
            <span className="text-[12px]" style={{ color: 'var(--text-secondary)' }}>{popis}</span>
            <span className="text-[13.5px] font-semibold tabular-nums" style={{ color: barva || 'var(--text-primary)' }}>{hodnota}</span>
        </div>
    );

    return (
        <>
            <div className="rounded-2xl p-4 flex-shrink-0" style={cardStyle}>
                <Nadpis>Zůstatek účtu</Nadpis>
                <div className="text-[28px] font-extrabold tabular-nums leading-none">{fmtKratce(staty.zustatek)} Kč</div>
                {ucetLabel && <div className="text-[11px] mt-1.5" style={{ color: 'var(--text-secondary)' }}>{ucetLabel}</div>}
            </div>

            <div className="rounded-2xl px-4 py-3.5 flex-shrink-0" style={cardStyle}>
                <Nadpis>{obdobiLabel}</Nadpis>
                <Radek popis="Příchozí" hodnota={`+${fmtKratce(staty.prichozi)}`} barva={OK} />
                <Radek popis="Odchozí" hodnota={`−${fmtKratce(staty.odchozi)}`} barva={BAD} />
                <Radek popis="Netto" hodnota={`${staty.netto >= 0 ? '+' : '−'}${fmtKratce(Math.abs(staty.netto))}`} />
                <Radek posledni popis="Nespárované"
                    hodnota={staty.nesparovano ? `${staty.nesparovano} · ${fmtKratce(staty.nesparovano_kc)}` : '—'}
                    barva={staty.nesparovano ? WARN : null} />
            </div>

            {zarazeni.length > 0 && (
                <div className="rounded-2xl px-4 py-3.5 flex-shrink-0" style={cardStyle}>
                    <Nadpis>Podle zařazení</Nadpis>
                    {zarazeni.map((z, i) => (
                        <div key={z.tag} style={{ marginBottom: i === zarazeni.length - 1 ? 0 : 8 }}>
                            <div className="flex justify-between text-[11.5px] mb-1">
                                <span className="truncate" style={{ marginRight: 8 }}>{KAT_LABEL[z.tag] || z.tag}</span>
                                <span className="tabular-nums flex-shrink-0" style={{ color: 'var(--text-secondary)' }}>{fmtKratce(z.suma)}</span>
                            </div>
                            <div style={{ height: 6, borderRadius: 3, background: 'rgba(255,255,255,0.06)' }}>
                                <div style={{ width: `${Math.max(2, Math.abs(z.suma) / maxZ * 100)}%`, height: 6, borderRadius: 3, background: ACCENT }} />
                            </div>
                        </div>
                    ))}
                </div>
            )}

            <div className="rounded-2xl px-4 py-3.5 flex-1 min-h-0" style={cardStyle}>
                <Nadpis>K dořešení{nalezy.length ? ` · ${nalezy.length}` : ''}</Nadpis>
                {nalezy.length === 0 ? (
                    <div className="text-[11.5px] leading-relaxed" style={{ color: 'var(--text-secondary)' }}>
                        Nic nevisí — každý pohyb má doklad nebo zařazení.
                    </div>
                ) : nalezy.map((n, i) => (
                    <button key={i} onClick={() => n.pohled && onPohled?.(n.pohled)}
                        className="w-full text-left px-3 py-2.5 rounded-[9px]"
                        style={{
                            marginBottom: i === nalezy.length - 1 ? 0 : 7,
                            background: `${n.barva}14`, border: `1px solid ${n.barva}38`,
                            cursor: n.pohled ? 'pointer' : 'default',
                        }}>
                        <b className="block text-[11.5px] leading-snug mb-0.5" style={{ color: n.barva }}>{n.titulek}</b>
                        <span className="text-[11.5px] leading-snug" style={{ color: 'var(--text-secondary)' }}>{n.detail}</span>
                    </button>
                ))}
            </div>
        </>
    );
}
